/** Destino guardado quando a pessoa abre um link do app sem estar logada (INT-06). */
const STORAGE_KEY = 'synap:pending-intent'
export const PENDING_INTENT_TTL_MS = 10 * 60 * 1000

const BLOCKED_PATHS = ['/login', '/register', '/select-profile', '/dashboard']

interface StoredIntent {
  path: string
  savedAt: number
}

/** Só caminhos do próprio app: começa com uma barra, sem `//`, sem barra invertida e sem esquema. */
export function isInternalPath(path: string): boolean {
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('\\')) return false
  if ([...path].some((char) => char.charCodeAt(0) < 0x20)) return false
  const pathname = path.split(/[?#]/)[0]
  return !BLOCKED_PATHS.includes(pathname) && pathname !== '/'
}

function storage(): Storage | null {
  try {
    return typeof window === 'undefined' ? null : window.sessionStorage
  } catch {
    return null
  }
}

export function savePendingIntent(path: string, now = Date.now()): void {
  if (!isInternalPath(path)) return
  try {
    storage()?.setItem(STORAGE_KEY, JSON.stringify({ path, savedAt: now } satisfies StoredIntent))
  } catch {
    // Sem storage: depois do login a pessoa cai na Hoje.
  }
}

export function clearPendingIntent(): void {
  try {
    storage()?.removeItem(STORAGE_KEY)
  } catch {
    // ignora
  }
}

/** Destino ainda válido, ou null. Um destino expirado ou inválido é apagado. */
export function readPendingIntent(now = Date.now()): string | null {
  let raw: string | null = null
  try {
    raw = storage()?.getItem(STORAGE_KEY) ?? null
  } catch {
    return null
  }
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw) as Partial<StoredIntent>
    const age = typeof parsed.savedAt === 'number' ? now - parsed.savedAt : Number.NaN
    if (typeof parsed.path === 'string' && isInternalPath(parsed.path) && age >= 0 && age <= PENDING_INTENT_TTL_MS) {
      return parsed.path
    }
  } catch {
    // valor corrompido
  }
  clearPendingIntent()
  return null
}

/** Para onde ir depois do login. */
export function postLoginPath(now = Date.now()): string {
  return readPendingIntent(now) ?? '/dashboard'
}
